// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/search/_index.scss
// module id = 73
// module chunks = 0